import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const ADD_ROLE = createActionType("ADD_ROLE");
export const GET_ROLES = createActionType("GET_ROLES");
export const EDIT_ROLE = createActionType("EDIT_ROLE");
export const REMOVE_ROLE = createActionType("REMOVE_ROLE");

export const addRole = (data: any) =>
  createAsyncAction(ADD_ROLE, "/role/add_role", "post", data, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });

export const getRoles = () =>
  createAsyncAction(GET_ROLES, "/role/get_roles", "get", undefined);

export const editRole = (id: any, data: any) =>
  createAsyncAction(EDIT_ROLE, `/role/edit_role/${id}`, "put", data, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });

export const removeRole = (id: any) =>
  createAsyncAction(
    REMOVE_ROLE,
    `/role/remove_role/${id}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
